import { apiClient } from '@/client'
import { userProfile } from '@/client/UserProfile'
const DEFAULT = {
  isLoggedIn: false,
  apiKey: null,
  email: null,
  showSubBox: true
}
const state = {
  profile: { ...DEFAULT },
  authError: false,
  activationError: false,
  signupError: false,
  resetKeyError: false,
  resetPasswordError: false
}
const getters = {
  showSubBox: state => state.profile.showSubBox || true,
  userLoggedIn: state => state.profile.isLoggedIn,
  authError: state => state.authError,
  signupError: state => state.signupError,
  resetKeyError: state => state.resetKeyError,
  resetPasswordError: state => state.resetPasswordError,
  activationError: state => state.activationError
}
const mutations = {
  SET_PROFILE: (state, payload) => {
    state.profile = payload
  }
}
const actions = {
  checkAuth: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      if (state.profile.isLoggedIn) {
        return resolve(true)
      }
      userProfile.getSessionToken().then(
        response => {
          const { apiKey, email } = response
          apiClient.setAPIKey(apiKey)
          apiClient.setEmail(email)
          commit('SET_PROFILE', { isLoggedIn: true, apiKey, email })
          return resolve(true)
        },
        e => {
          // console.log(e)
          commit('SET_PROFILE', { ...DEFAULT })
          return reject(e)
        }
      )
    })
  },
  login: ({ commit, state }, creds) => {
    return new Promise((resolve, reject) => {
      apiClient
        .login(creds)
        .then(response => {
          userProfile.storeSessionToken(response)
          commit('SET_PROFILE', { ...state.profile, ...response, isLoggedIn: true })
          resolve(true)
        })
        .catch(reject)
    })
  },
  logout: ({ commit }) => {
    return new Promise((resolve, reject) => {
      userProfile.deleteSessionToken()
      apiClient.logout().then(response => {
        commit('SET_PROFILE', { ...DEFAULT })
        resolve(true)
      })
    })
  },
  signup: ({ commit }, creds) => {
    return new Promise((resolve, reject) => {
      apiClient
        .signup(creds)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  activate: ({ commit }, creds) => {
    return new Promise((resolve, reject) => {
      apiClient
        .activate(creds)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  resetKey: ({ commit }, creds) => {
    return new Promise((resolve, reject) => {
      apiClient
        .resetKey(creds)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  resetPassword: ({ commit }, creds) => {
    return new Promise((resolve, reject) => {
      apiClient
        .resetPassword(creds)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  }
}

export default { state, getters, mutations, actions }
